import { useState, useEffect, useCallback } from "react"
import {
  getGlitchIntensity,
  setGlitchIntensity as setStorage,
  GLITCH_CHANGE_EVENT,
  GLITCH_INTENSITY_DEFAULT,
  GLITCH_INTENSITY_MIN,
  GLITCH_INTENSITY_MAX,
} from "./glitchIntensity"

export function useGlitchIntensity(): [number, (value: number) => void] {
  const [value, setValue] = useState(getGlitchIntensity)

  useEffect(() => {
    const handler = () => setValue(getGlitchIntensity())
    window.addEventListener(GLITCH_CHANGE_EVENT, handler)
    return () => window.removeEventListener(GLITCH_CHANGE_EVENT, handler)
  }, [])

  const set = useCallback((v: number) => {
    setStorage(v)
    setValue(getGlitchIntensity())
  }, [])

  return [value, set]
}

export {
  GLITCH_INTENSITY_DEFAULT,
  GLITCH_INTENSITY_MIN,
  GLITCH_INTENSITY_MAX,
}
